module.exports = __webpack_public_path__ + "img/smile5.0.c2574d10.svg";